import { DateFormatter } from './date.js';
import { ParserFormatter } from './core.js';

export class DatetimeFormatter extends DateFormatter {
  constructor(
    locales?: string | string[],
    options: Intl.DateTimeFormatOptions = { timeStyle: 'medium' }
  ) {
    super(locales, options);
  }
}

export class ISODatetimeParserFormatter extends ParserFormatter<Date> {
  protected intlFormatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeStyle: 'short',
  });

  get type() {
    return 'datetime-local';
  }

  format(value: Date): string {
    const parts = new Map(
      this.intlFormatter
        .formatToParts(value)
        .map(part => [part.type, part.value])
    );

    return `${parts.get('year')!.padStart(4, '0')}-${parts.get(
      'month'
    )}-${parts.get('day')}T${parts.get('hour')}:${parts.get('minute')}`;
  }

  parse(valueStr: string): Date {
    return new Date(Date.parse(valueStr));
  }
}

export function isoDatetimeParserFormatter() {
  return new ISODatetimeParserFormatter();
}

export function datetimeFormatter(
  locales?: string | string[],
  options?: Intl.DateTimeFormatOptions
): DatetimeFormatter;

export function datetimeFormatter(
  options: Intl.DateTimeFormatOptions
): DatetimeFormatter;

export function datetimeFormatter(
  localesOrOptions?: string | string[] | Intl.DateTimeFormatOptions,
  options?: Intl.DateTimeFormatOptions
): DatetimeFormatter {
  if (
    !localesOrOptions ||
    typeof localesOrOptions === 'string' ||
    Array.isArray(localesOrOptions)
  ) {
    return new DatetimeFormatter(localesOrOptions, options);
  }
  return new DatetimeFormatter(undefined, localesOrOptions);
}
